/*eslint-disable*/
import Loader from "components/Loader";
import React, {
  createContext,
  FC,
  useCallback,
  useEffect,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import { useLifeChoice } from "store/api/LifeChoiceBlocks";
import {
  ILifeChoicePageContext,
  ILifeChoiceTabsType,
  ILifeChoiceTabs,
  ILifeChoiceProviderProps,
} from "types/context/lifeChoicePage";

export const LifeChoicePageContext = createContext(
  {} as ILifeChoicePageContext
);

const LifeChoiceProvider: FC<ILifeChoiceProviderProps> = (props) => {
  const [activeTab, setTab] = useState<ILifeChoiceTabsType>(
    ILifeChoiceTabs.OVERVIEW
  );
  const [lifeChoice, setLifeChoice] = useState<any>(null);

  const tabHandler = useCallback(
    (tab: ILifeChoiceTabsType) => {
      setTab(tab);
    },
    [setTab, activeTab]
  );

  const { id } = useParams();
  const { data } = useLifeChoice({ id: id! });

  useEffect(() => {
    if (data) {
      setLifeChoice(data);
    }
  }, [data]);

  if (!lifeChoice) return <Loader open={true} />;

  return (
    <LifeChoicePageContext.Provider
      value={{ activeTab, tabHandler, lifeChoice, setLifeChoice }}
      {...props}
    />
  );
};

export default LifeChoiceProvider;
